module.exports = __webpack_public_path__ + "media/modules/spinners/components/large_spinner-1da56667fcd1523fe9a8565063b1616d.gif";